export const EXTERNAL_URLS = {
  // Resources menu URLs
  VIDEO_TUTORIALS:
    'https://youtube.com/playlist?list=PL-8PuDFiYyOkcQ5_r_QvCkL3kfatPFjb0&si=JYzS4_hayx1EieFP',
  WEBINARS: 'https://help.pitch59.com/webinars',
  FAQS: 'https://help.pitch59.com/knowledge/faq',
  HELP_CENTER: 'https://help.pitch59.com/knowledge',
  BLOG: 'https://blog.pitch59.com/pitch59-blog',

  // Social media URLs
  FACEBOOK: 'https://facebook.com/pitch59',
  TWITTER: 'https://twitter.com/pitch59',
  LINKEDIN: 'https://linkedin.com/company/pitch59',
  INSTAGRAM: 'https://instagram.com/pitch59',

  // Support URLs
  CONTACT_SUPPORT: 'https://help.pitch59.com/contact',
  PRIVACY_POLICY: 'https://pitch59.com/privacy-policy',
  TERMS_OF_SERVICE: 'https://pitch59.com/terms-of-service',
  AFFILIATE_TERMS: 'https://pitch59.com/affiliate-terms-and-conditions',

  // App store URLs
  APP_STORE: 'https://apps.apple.com/us/app/pitch59/id1502156356',
  GOOGLE_PLAY:
    'https://play.google.com/store/apps/details?id=com.pitch.fiftynine',

  // Blog URLs
  BLOG_NETWORKING:
    'https://blog.pitch59.com/pitch59-blog/networking-building-bridges-for-business-growth',
  BLOG_PITCH_VIDEOS:
    'https://blog.pitch59.com/pitch59-blog/the-power-of-pitch-videos',
  BLOG_GETTING_REFERRALS:
    'https://blog.pitch59.com/pitch59-blog/getting-referrals',
  BLOG_UNLEASH_POWER:
    'https://blog.pitch59.com/pitch59-blog/unleash-the-power-of-pitch-videos',

  REFERAL_SPRINTS: 'https://blog.pitch59.com/pitch59-blog/referral-sprints',

  WHAT_CAN_HAPPEN:
    'https://blog.pitch59.com/pitch59-blog/the-referral-sprint-experiment',

  PLACES_TO_SHARE:
    'https://blog.pitch59.com/pitch59-blog/15-places-to-share-your-digital-business-card',

  // Team manager setup
  TEAM_MANAGER_SETUP: 'https://help.pitch59.com/knowledge/team-manager-setup',

  // Main website
  MAIN_WEBSITE: 'https://pitch59.com',

  // Email addresses
  EMAIL_SALES: 'sales@pitch59.com',
  EMAIL_HELP: 'help@pitch59.com',
  EMAIL_MANAGEMENT: 'management@pitch59.com',
  EMAIL_AFFILIATE_RELATIONS: 'affiliate_relations@pitch59.com'
} as const;

export type ExternalUrlKey = keyof typeof EXTERNAL_URLS;
